import { OrderMethod } from '../../../../../services/exports/Constants';

export default {
  [OrderMethod.Pickup]: 'Recolha',
  [OrderMethod.Delivery]: 'Entrega',
  [OrderMethod.OnSite]: 'Pedido à mesa',
};
